import { useApiWithAuth } from "@/modules/api";

type PeriodoComparativoTipo = "MENSAL" | "TRIMESTRAL" | "SEMESTRAL" | "ANUAL";

interface FaturamentoDiaPayload {
  dia?: string | null;
  quantidade?: number | null;
}

interface FaturamentoComparativoPayload {
  serieAtual?: FaturamentoDiaPayload[] | null;
  serieAnoAnterior?: FaturamentoDiaPayload[] | null;
  inicioAtual?: string | null;
  inicioAnoAnterior?: string | null;
  granularidade?: "day" | "week" | "month" | null;
  totalBuckets?: number | null;
  bucketAtual?: number | null;
}

const useFaturamentoComparativoService = () => {
  const { data, loading, get } = useApiWithAuth();

  const getComparativoFaturamento = (
    tipo: PeriodoComparativoTipo,
    referencia?: string
  ): Promise<void> => {
    return get(`/root/dashboard/faturamento/comparativo`, {
      tipo,
      referencia
    });
  };

  return {
    data,
    loading,
    getComparativoFaturamento
  };
};

export {
  useFaturamentoComparativoService,
  FaturamentoDiaPayload,
  FaturamentoComparativoPayload,
  PeriodoComparativoTipo
};
